import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetAgentCardByPage(params, pageNum = 1, size = 10) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/getCardByPage/${pageNum}/${size}`,
    params: params,
  });
}
